export default function () {
  const buttonsLoadMore = Array.from(
    document.querySelectorAll(
      '.CareCredit__posts-container .CareCredit__posts--load-more-btn'
    )
  )

  buttonsLoadMore.forEach((button) => {
    button.addEventListener('click', loadMoreArticleList)
  })
}

async function loadMoreArticleList() {
  const button = this
  const query = button.dataset?.query || ''
  const currentTotal = parseInt(button.dataset?.currentTotal) || 0
  const total = parseInt(button.dataset?.total) || 0

  lockButton(button)

  let params = [`offset=${currentTotal}`, `query=${query}`]

  const data = await fetchArticleList(params)

  if (!data) {
    const elemError = createErrorMessage()

    button.parentNode.insertBefore(elemError, button)
    button.remove()

    return false
  }

  const container = button.parentNode
  const articleList = container.querySelector('.CareCredit__posts--load-more')

  const list = data.article_list
  const newCurrentTotal = currentTotal + list.length
  let newFirstArticle = null

  list.forEach(function (item, index) {
    const card = createCard(item)

    if (0 === index) {
      newFirstArticle = articleList.appendChild(card)
    } else {
      articleList.appendChild(card)
    }
  })

  unlockButton(button)
  updateCurrentTotal(button, newCurrentTotal)

  if (newCurrentTotal >= total) {
    button.remove()
  }

  focusInCard(newFirstArticle)
}

function updateCurrentTotal(button, newValue) {
  button.setAttribute('data-current-total', newValue)
}

function lockButton(button) {
  if (!button) {
    return
  }

  button.classList.add('blocked')
  button.textContent = button.dataset?.loading || ''
}

function unlockButton(button) {
  if (!button) {
    return
  }

  button.classList.remove('blocked')
  button.textContent = button.dataset?.load || ''
}

function focusInCard(card) {
  if (!card) {
    return
  }

  const scrollPosition = card.offsetTop
  const cardLink = card.querySelector('.text-content h1 > a')

  window.scrollTo(0, scrollPosition)
  cardLink.focus()
}

function createCard(item) {
  const card = document.createElement('div')
  card.classList.add('CareCredit__posts--load-more-item')

  card.innerHTML = `${createImage(item.thumbnail_url, item.title, item.url)}
  <div class="text-content">
    <div class="title-container">
      <h1><a href="${item.url}">${item.title}</a></h1>
    </div>
  </div>`

  return card
}

function createImage(image, alt, link) {
  if (!image) {
    return ''
  }

  return `<figure>
    <a href="${link}">
      <img src="${image}" alt="${alt}" title="${alt}" />
    </a>
  </figure>`
}

function createErrorMessage() {
  const elemError = document.createElement('div')
  elemError.classList.add('CareCredit__posts--error-message')
  elemError.textContent = 'Posts not found'
  return elemError
}

async function fetchArticleList(params) {
  const response = await fetch(
    `/wp-json/load-more/v1/posts?${params.join('&')}`,
    {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )

  try {
    const json = await response.json()

    if (!json.success) {
      return null
    }

    return json?.data
  } catch (e) {}

  return null
}
